<script lang="ts">
	// The onboarding's printers step (T27, UC-59, #774): the till's printers by
	// name and what each prints, and Set up printers, which opens T25. It
	// summarises them and never holds T25's own panel.
	import Button from '../components/Button.svelte';
	import { message, type Language } from '../i18n/messages';
	import type { Printer } from '../till/printers.svelte';
	import { printsWhat } from './Printers.svelte';
	interface Props {
		language: Language;
		printers: Printer[];
		disabled?: boolean;
		onOpen: () => void;
	}
	let { language, printers, disabled = false, onOpen }: Props = $props();
</script>

<div class="step">
	<h3>{message(language, 'printersTitle')}</h3>
	<div class="printers">
		{#each printers as printer (printer.id)}
			<div class="printer" data-testid="setup-printer-{printer.id}">
				<strong>{printer.name}</strong><span>{printsWhat(language, printer)}</span>
			</div>
		{:else}
			<p data-testid="setup-printers-empty">{message(language, 'printersEmpty')}</p>
		{/each}
	</div>
	<div>
		<Button
			testId="setup-printers-open"
			label={message(language, 'setupPrintersOpen')}
			tone="secondary"
			{disabled}
			onPress={onOpen}
		/>
	</div>
</div>

<style>
	.step {
		display: flex;
		flex-direction: column;
		gap: var(--space-7);
	}
	h3 {
		margin: 0;
		font-size: var(--text-h4);
	}
	.printers {
		display: flex;
		flex-direction: column;
		gap: var(--space-5);
	}
	.printer {
		display: flex;
		flex-direction: column;
		gap: var(--space-2);
	}
	span,
	p {
		margin: 0;
		color: var(--text-body);
	}
</style>
